import * as Cesium from 'cesium';
import { Exception } from 'sass';
import styled from 'styled-components';
import { makeStyles } from "@mui/styles";
import ApiInterface from 'utils/ApiInterface';
import { CollectionCategoryEnum } from 'Enums';
import StacInterface from "utils/StacInterface";
import React, { useEffect, useState } from 'react';
import UpgradeModal from "components/UpgradeModal";
import { getCameraFocus } from '../MapView/MapUtils';
import { useDispatch, useSelector } from "react-redux";
import useViewerStore from '../../store-zustand/viewer';
import { createMetadata, getLayerCollectionDetail } from "@/utils/helpers";
import { turnOffLayers, turnOffLayer, showLayer, showAlert } from '../../helper';
import { CircularProgress, IconButton, Tooltip, MenuItem, Menu } from "@mui/material";
import { ChevronLeft, ChevronRight, ArrowDropDown, ArrowDropUp, InfoOutlined, Compare } from "@mui/icons-material";

const Wrapper = styled.footer`
  float: bottom;
  width: 100%;
  padding: 10px 30px;
  background: rgb(35, 35, 35);

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    > div {
      display: grid;
    }
  }
`
const copyright = {
  color: "white",
  float: "left",
  fontFamily: "Roboto",
  fontSize: '12px',
  fontWeight: '700',
  whiteSpace: "pre",
  marginLeft: "8px",
  marginTop: '2px',
};

const mapdata = {
  textAlign: "right",
  color: "white",
  float: "right",
  fontFamily: "Roboto",
  fontSize: '12px',
  fontWeight: '500',
  whiteSpace: "pre"
};

const date = {
  color: "white",
  float: "left",
  fontFamily: "Roboto",
  fontSize: '12px',
  fontWeight: '500',
  whiteSpace: "pre",
  marginLeft: '5px',
  marginTop: '1px'
};

const compareDateLeft = {
  color: "white",
  fontFamily: "Roboto",
  fontSize: '12px',
  fontWeight: '500',
  whiteSpace: "pre",
  marginTop: '1px',
  position: 'absolute',
  left: 'calc(50% - 0px)',
  transform: 'translate(-100%, 0)',
};

const compareDateRight = {
  color: "white",
  fontFamily: "Roboto",
  fontSize: '12px',
  fontWeight: '500',
  whiteSpace: "pre",
  marginTop: '1px',
  position: 'absolute',
  left: 'calc(50% + 0px)',
};

const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: "white",
    fontSize: "12px !important",
    backgroundColor: "#5A5A5A",
    borderRadius: 3,
    fontFamily: "Roboto",
    padding: "8px 10px",
    fontWeight: 500,
  },
}));

const ButtonIcon = styled(IconButton)`
  transition: all 0.35s;
  svg {
    pointer-events: none;
    ${(props) => (props.bluebg ? "fill: #E5E5E5" : "fill: #A0A0A0")};
    transition: all 0.35s;
  }

  &:hover {
    ${(props) =>
    props.bluebg
      ? "background-color: rgba(72, 123, 242, 0.9) !important;"
      : "background-color: rgba(255, 255, 255, 0.1) !important;"}
    color: white !important;

    svg {
      fill: white;
    }
  }
`;

const Footer = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { viewer } = useViewerStore();
  const compareTool = useSelector(state => state.settings.compareTool);
  const selectedMission = useSelector(state => state.asset.selectedMission);
  const selectedOblique = useSelector(state => state.asset.selectedOblique);
  const showObliquesModal = useSelector(state => state.settings.showObliquesModal);
  const selectedImageryMode = useSelector(state => state.asset.selectedImageryMode);
  const showMetadataModal = useSelector(state => state.settings.showMetadataModal);
  const [visibleCollections, setVisibleCollections] = useState();
  const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false);
  const [selected, setSelected] = useState(0);
  const [menuAnchorEl, setMenuAnchorEl] = useState();
  const [selectedCollection, setSelectedCollection] = useState();
  const [repeatedDatesInColletion, setRepeatedDatesInColletion] = useState({});
  const [collectionMenuAnchorEl, setCollectionMenuAnchorEl] = useState();
  const [leftMissionDate, setLeftMissionDate] = useState();
  const [leftMenuAnchorEl, setLeftMenuAnchorEl] = useState();
  const [rightMissionDate, setRightMissionDate] = useState();
  const [rightMenuAnchorEl, setRightMenuAnchorEl] = useState();
  const [leftCollection, setLeftCollection] = useState();
  const [leftCollectionMenuAnchorEl, setLeftCollectionMenuAnchorEl] = useState();
  const [rightCollection, setRightCollection] = useState();
  const [rightCollectionMenuAnchorEl, setRightCollectionMenuAnchorEl] = useState();
  const [userIsFreemium, setUserIsFreemium] = useState(true);
  
  const menuOpen = Boolean(menuAnchorEl);
  const rightMenuOpen = Boolean(rightMenuAnchorEl);
  const leftMenuOpen = Boolean(leftMenuAnchorEl);
  const collectionMenuOpen = Boolean(collectionMenuAnchorEl);
  const rightCollectionMenuOpen = Boolean(rightCollectionMenuAnchorEl);
  const leftCollectionMenuOpen = Boolean(leftCollectionMenuAnchorEl);

  let coordinates = '';
  let camera_height = '';
  let coordinates_height = '';
  if (props.location) {
    [camera_height, coordinates, coordinates_height] = props.location.split("@");
  }

  const not_comparable_collection_category = [CollectionCategoryEnum.oblique_photo_mosaic, CollectionCategoryEnum.oblique_photo_tileset]

  const resetMapOrientation = () => {
    if (!viewer) return;
    viewer.camera.flyTo({
      destination: viewer.camera.position.clone(),
      orientation: {
        heading: 0,
        pitch: viewer.camera.pitch,
        roll: viewer.camera.roll,
      },
    });
  };

  const setImageInfo = () => {
    var camFocus = getCameraFocus(window.MAIN_CESIUM_VIEWER);
    if (camFocus) {
      var cartoCamFocus = Cesium.Ellipsoid.WGS84.cartesianToCartographic(camFocus);
      var lon = cartoCamFocus.longitude * Cesium.Math.DEGREES_PER_RADIAN;
      var lat = cartoCamFocus.latitude * Cesium.Math.DEGREES_PER_RADIAN;

      const [_, collection] = getLayerCollectionDetail(selectedMission);
      let layer_name = selectedMission;
      if (collection.category === CollectionCategoryEnum.oblique_photo_tileset || collection.category === CollectionCategoryEnum.oblique_photo_mosaic) {
        layer_name = selectedOblique;
      }

      if (layer_name === undefined) {
        dispatch({ type: 'SET_ASSET_METADATA', assetMetaData: {} });
        dispatch({ type: 'TOGGLE_METADATA_MODAL', show: false });
        return;
      }

      StacInterface.instance.getMissionInfoAtPoint(lon, lat, layer_name).then((response) => {
        let info = createMetadata(response.data);
        dispatch({ type: 'SET_ASSET_METADATA', assetMetaData: info });
        dispatch({ type: 'TOGGLE_METADATA_MODAL', show: true });
      }).catch((error) => {
        showAlert('error', `Error in getting imagery metadata. ${error.response.data?.detail}`)
        dispatch({ type: 'SET_ASSET_METADATA', assetMetaData: {} });
        dispatch({ type: 'TOGGLE_METADATA_MODAL', show: false });
      });
    }
  }

  const isUserFreemium = async () => {
    const userProfile = await ApiInterface.instance.userProfile().catch((error) => null)
    if (userProfile === null ||
      userProfile !== null && (userProfile.data.metadata?.plan === undefined || userProfile.data.metadata?.plan?.toLowerCase() === 'freemium')) {
      return true;
    }

    return false;
  }

  const imageInfo = () => {
    if (userIsFreemium) {
      setUpgradeModalIsOpen(true);
      return;
    }

    setImageInfo();
  }

  const findRepeatedDatesInCollection = (missionDates) => {
    if (!missionDates) return;

    let collectionDates = missionDates.map((mission, index) => {
      let [_, collection] = getLayerCollectionDetail(Object.keys(mission)[0]);
      let date = Object.values(mission)[0];
      return collection.name + ':' + date;
    });

    let repeatedDatesInColletion = {};
    collectionDates.forEach((collectionDate, index) => {
      let collection = collectionDate.split(':')[0];
      if (index !== collectionDates.indexOf(collectionDate)) {
        if (repeatedDatesInColletion[collection] === undefined) {
          repeatedDatesInColletion[collection] = [index];
        } else {
          repeatedDatesInColletion[collection].push(index);
        }
      }
    });
    setRepeatedDatesInColletion(repeatedDatesInColletion);
  }

  const showMissionsWithSameDateInCollection = () => {
    if (!props.missionDates || !props.missionDates[selected]) return;
    let missionsWithSameDateInCollection = [Object.keys(props.missionDates[selected])[0]];
    let selectedDatetime = props.missionDates[selected][Object.keys(props.missionDates[selected])[0]]
    props.missionDates.forEach((mission, index) => {
      if (mission[Object.keys(mission)[0]] === selectedDatetime &&
        Object.keys(mission)[0] !== Object.keys(props.missionDates[selected])[0] &&
        Object.keys(mission)[0].split(':')[0] === Object.keys(props.missionDates[selected])[0].split(':')[0]) {
        missionsWithSameDateInCollection.push(Object.keys(mission)[0]);
      }
    });

    if (missionsWithSameDateInCollection.length > 0) turnOffLayers(missionsWithSameDateInCollection);
  }

  const prevDate = () => {
    let indices = []
    props.missionDates.map((mission, index) => {
      let [_, collection] = getLayerCollectionDetail(Object.keys(mission)[0]);
      if (collection.name === window.demonstrable_collections[selectedCollection].name) {
        indices.push(index)
      }
    })

    let selected_index = indices.indexOf(selected)
    if (selected_index + 1 < indices.length) {
      setSelected(indices[selected_index + 1]);
    }
  }

  const nextDate = () => {
    let indices = []
    props.missionDates.map((mission, index) => {
      let [_, collection] = getLayerCollectionDetail(Object.keys(mission)[0]);
      if (collection.name === window.demonstrable_collections[selectedCollection].name) {
        indices.push(index)
      }
    })

    let selected_index = indices.indexOf(selected)
    if (selected_index - 1 >= 0) {
      setSelected(indices[selected_index - 1]);
    }
  }

  useEffect(() => {
    isUserFreemium().then(userFremium => {
      if (userFremium) {
        setUserIsFreemium(true);
      } else {
        setUserIsFreemium(false);
      }
    });
  }, [])

  useEffect(() => {
    if (selectedOblique === undefined) return;
    if (showMetadataModal === false) return;

    imageInfo();
  }, [selectedOblique])

  useEffect(() => {
    if (selectedMission === undefined) return;
    if (showMetadataModal === false) return;

    imageInfo();
  }, [selectedMission])

  useEffect(() => {
    if (props.missionDates === undefined || props.missionDates.length === 0) return;
    
    turnOffLayers();
    if (props.missionDates[selected] === undefined) return;
    
    const layer_name = Object.keys(props.missionDates[selected])[0];
    dispatch({ type: 'SET_SELECTED_MISSION', selectedMission: layer_name })
    let [_, collection] = getLayerCollectionDetail(layer_name);
    if (collection.category === CollectionCategoryEnum.oblique_photo_tileset || collection.category === CollectionCategoryEnum.oblique_photo_mosaic) {
      window.selectedHDImagery = layer_name;
    } else {
      if (selectedImageryMode in window.HDImagery[layer_name]) {
        showLayer(layer_name, null, selectedImageryMode, Cesium.SplitDirection.NONE)
        window.selectedHDImagery = layer_name;
      } else {
        let imageryMode = Object.keys(window.HDImagery[layer_name])[0]
        showLayer(layer_name, null, imageryMode, Cesium.SplitDirection.NONE)
        window.selectedHDImagery = layer_name;
      }
    }

    showMissionsWithSameDateInCollection();
  }, [selected, selectedImageryMode])

  useEffect(() => {
    if (selectedCollection === undefined) return;
    if (props.missionDates === undefined || props.missionDates.length === 0) return;

    for (let key in props.missionDates) {
      const layer_name = Object.keys(props.missionDates[key])[0];
      let [_, collection] = getLayerCollectionDetail(layer_name);
      if (collection.name === window.demonstrable_collections[selectedCollection].name) {
        if (collection.category === CollectionCategoryEnum.oblique_photo_tileset || collection.category === CollectionCategoryEnum.oblique_photo_mosaic) {
          dispatch({ type: 'TOGGLE_OBLIQUE_MODAL', show: true });
          window.ortho = false;
        } else {
          if (showObliquesModal) {
            dispatch({ type: 'TOGGLE_OBLIQUE_MODAL', show: false });
            dispatch({ type: 'SET_SELECTED_OBLIQUE', selectedOblique: undefined })
            window.ortho = true;
            resetMapOrientation();
          }
        }
        setSelected(undefined);
        setTimeout(() => {setSelected(key)}, 0);
        break;
      }
    }
  }, [selectedCollection])

  useEffect(() => { 
    if (window.demonstrable_collections === undefined ) return;
    if (window.HDImagery === undefined || Object.keys(window.HDImagery).length === 0) return;
    if (props.missionDates === undefined || props.missionDates.length === 0) {
      setSelected(0);
      turnOffLayers();
      dispatch({ type: 'SET_OBLIQUE_ASSETS' });
      dispatch({ type: 'SET_SELECTED_MISSION' });
      dispatch({ type: 'SET_OBLIQUE_AVAILABLE' });
      return;
    }

    const visible_collections = Array.from(new Set(props.missionDates.map((mission) => { 
      const [, collection] = getLayerCollectionDetail(Object.keys(mission)[0]);
      return collection.name;
    })));
    setVisibleCollections(visible_collections);

    if (compareTool === false) {
      const current_layer_exists_at_location = selectedMission !== undefined && props.missionDates.map((date) => Object.keys(date)[0]).includes(selectedMission)
      if (selectedMission === undefined || current_layer_exists_at_location === false) {
        const first_layer_name = Object.keys(props.missionDates[0])[0];
        const [collection_index] = getLayerCollectionDetail(first_layer_name);
        setSelectedCollection(undefined);
        setTimeout(() => {setSelectedCollection(collection_index)}, 0);
      }
    } else {
      const right_layer_name = Object.keys(rightMissionDate)[0];
      const right_layer_exists_at_location = rightMissionDate !== undefined && props.missionDates.map((date) => Object.keys(date)[0]).includes(right_layer_name)
      if (rightMissionDate === undefined || right_layer_exists_at_location === false) {
        const first_layer_name = Object.keys(props.missionDates[0])[0];
        const [collection_index] = getLayerCollectionDetail(first_layer_name);
        setRightCollection(undefined);
        setTimeout(() => {setRightCollection(collection_index)}, 0);
      }
      
      const left_layer_name = Object.keys(leftMissionDate)[0];
      const left_layer_exists_at_location = leftMissionDate !== undefined && props.missionDates.map((date) => Object.keys(date)[0]).includes(left_layer_name)
      if (leftMissionDate === undefined || left_layer_exists_at_location === false) {
        const first_layer_name = Object.keys(props.missionDates[0])[0];
        const [collection_index] = getLayerCollectionDetail(first_layer_name);
        setLeftCollection(undefined);
        setTimeout(() => {setLeftCollection(collection_index)}, 0);
      }
    }
    
    findRepeatedDatesInCollection(props.missionDates);
  }, [props.missionDates])

  useEffect(() => {
    if (leftMissionDate === undefined) return;

    const left_layer = Object.keys(leftMissionDate)[0];
    const right_layer = rightMissionDate ? Object.keys(rightMissionDate)[0] : undefined ;
    Object.keys(window.HDImagery).map(layer => {
      let [_, collection] = getLayerCollectionDetail(layer);  
      const missionStyle = [CollectionCategoryEnum.terrain_mosaic, CollectionCategoryEnum.terrain_tileset].includes(collection.category) ? window.style.terrain : window.style.mosaic;
      if (layer !== right_layer && layer !== left_layer) {
        turnOffLayer(layer);
      }
      
      if (layer === left_layer) {
        showLayer(left_layer, null, missionStyle, Cesium.SplitDirection.LEFT);
      }
    })
  }, [leftMissionDate])

  useEffect(() => { 
    if (rightMissionDate === undefined) return;

    const left_layer = leftMissionDate ? Object.keys(leftMissionDate)[0] : undefined ;
    const right_layer = Object.keys(rightMissionDate)[0];
    Object.keys(window.HDImagery).map(layer => {
      let [_, collection] = getLayerCollectionDetail(layer);  
      const missionStyle = [CollectionCategoryEnum.terrain_mosaic, CollectionCategoryEnum.terrain_tileset].includes(collection.category) ? window.style.terrain : window.style.mosaic;
      if (layer !== right_layer && layer !== left_layer) {
        turnOffLayer(layer);
      }
      
      if (layer === right_layer) {
        showLayer(right_layer, null, missionStyle, Cesium.SplitDirection.RIGHT);
      }
    })
  }, [rightMissionDate])
  
  useEffect(() => {
    if (compareTool === false) return;
    if (leftCollection === undefined || rightMissionDate === undefined) return;
    if (props.missionDates === undefined || props.missionDates.length === 0) return;
    
    const right_layer_name = Object.keys(rightMissionDate)[0];
    for (let key in props.missionDates) {
      const layer_date = props.missionDates[key];
      const layer_name = Object.keys(layer_date)[0];
      const [_, collection] = getLayerCollectionDetail(layer_name);
      if (collection.name === window.demonstrable_collections[leftCollection].name && layer_name !== right_layer_name) {
        setLeftMissionDate(layer_date)
        break;
      }
    }
  }, [leftCollection])

  useEffect(() => {
    if (compareTool === false) return;
    if (rightCollection === undefined) return;
    if (props.missionDates === undefined || props.missionDates.length === 0) return;
    
    for (let key in props.missionDates) {
      const layer_date = props.missionDates[key];
      const layer_name = Object.keys(layer_date)[0];
      let [_, collection] = getLayerCollectionDetail(layer_name);
      if (collection.name === window.demonstrable_collections[rightCollection].name) {
        setRightMissionDate(layer_date);
        break;
      }
    }
    
    if (leftCollection === undefined) setLeftCollection(rightCollection);
  }, [rightCollection])

  useEffect(() => {
    if (compareTool === true) {
      turnOffLayers();
      if (rightMissionDate !== undefined ) {
        const layer_name = Object.keys(rightMissionDate)[0];
        const [collection_index, collection] = getLayerCollectionDetail(layer_name);
        let mission_style = (collection.category === CollectionCategoryEnum.terrain_mosaic || collection.category === CollectionCategoryEnum.terrain_tileset) ? window.style.terrain : window.style.mosaic;
        showLayer(layer_name, null, mission_style, Cesium.SplitDirection.RIGHT)
      }
      
      if (leftMissionDate !== undefined ) {
        const layer_name = Object.keys(leftMissionDate)[0];
        const [collection_index, collection] = getLayerCollectionDetail(layer_name);
        let mission_style = (collection.category === CollectionCategoryEnum.terrain_mosaic || collection.category === CollectionCategoryEnum.terrain_tileset) ? window.style.terrain : window.style.mosaic;
        showLayer(layer_name, null, mission_style, Cesium.SplitDirection.LEFT)
      }

      if (selectedCollection !== undefined) setRightCollection(selectedCollection);
    } else {
      turnOffLayers();
      if (selectedMission !== undefined){
        const [collection_index, collection] = getLayerCollectionDetail(selectedMission);
        let mission_style = (collection.category === CollectionCategoryEnum.terrain_mosaic || collection.category === CollectionCategoryEnum.terrain_tileset) ? window.style.terrain : window.style.mosaic;
        showLayer(selectedMission, null, mission_style, Cesium.SplitDirection.NONE)
      }
    }
  }, [compareTool])

  const handleMainCollectionChange = (collection_index) => {
    setSelectedCollection(collection_index);
    setCollectionMenuAnchorEl(null);
  }

  const handleMainMissionChange = (mission) => {
    setSelected(mission);
    setMenuAnchorEl(null);
  }

  const handleLeftCollectionChange = (collection_index) => {
    setLeftCollection(collection_index); 
    setLeftCollectionMenuAnchorEl(null);
  }
  
  const handleLeftMissionChange = (mission) => {
    setLeftMissionDate(mission); 
    setLeftMenuAnchorEl(null);
  }
  
  const handleRightCollectionChange = (collection_index) => {
    setRightCollection(collection_index); 
    setRightCollectionMenuAnchorEl(null);
  }
  
  const handleRightMissionChange = (mission) => {
    setRightMissionDate(mission); 
    setRightMenuAnchorEl(null);
  }

  const getCollectionMenuItems = (collection_place) => {
    return window.demonstrable_collections.map((collection, index) => {
      if (visibleCollections.includes(collection.name)) {
        if (collection_place === 'main') {
          return (<MenuItem key={index} value={index} onClick={() => handleMainCollectionChange(index)}>{collection.name}</MenuItem>)
        } else if (collection_place === 'left_split') {
          if (not_comparable_collection_category.includes(collection.category)) {
            return (<MenuItem disabled key={index} value={index} onClick={() => handleLeftCollectionChange(index)}>{collection.name}</MenuItem>)
          } else {
            return (<MenuItem key={index} value={index} onClick={() => handleLeftCollectionChange(index)}>{collection.name}</MenuItem>)
          }
        } else if (collection_place === 'right_split') {
          if (not_comparable_collection_category.includes(collection.category)) {
            return (<MenuItem disabled key={index} value={index} onClick={() => handleRightCollectionChange(index)}>{collection.name}</MenuItem>)
          } else {
            return (<MenuItem key={index} value={index} onClick={() => handleRightCollectionChange(index)}>{collection.name}</MenuItem>)
          }
        } else {
          throw Exception('Bad collection_place value');
        }
      }
    })
  }

  const getMissionMenuItems = (mission_place) => {
    return props.missionDates.map((mission, index) => {
      const layer_name = Object.keys(mission)[0];
      let [_, collection] = getLayerCollectionDetail(layer_name);
      if (mission_place === 'main') {
        if (collection.name === window.demonstrable_collections[selectedCollection].name && (!repeatedDatesInColletion || !repeatedDatesInColletion[collection] || !repeatedDatesInColletion[collection].includes(index))) {
          return (<MenuItem key={index} value={index} onClick={() => handleMainMissionChange(index)}>{new Date(Object.values(mission)[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' })}</MenuItem>)
        }
      } else if (mission_place === 'left_split') {
        if (collection.name === window.demonstrable_collections[leftCollection].name)
          if (rightMissionDate && layer_name !== Object.keys(rightMissionDate)[0])
            return (<MenuItem key={index} id={"left_" + mission} onClick={() => {handleLeftMissionChange(mission)}}>{new Date(Object.values(mission)[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' })}</MenuItem>)
      } else if (mission_place === 'right_split') {
        if (collection.name === window.demonstrable_collections[rightCollection].name)
          if (leftMissionDate && layer_name !== Object.keys(leftMissionDate)[0])
            return (<MenuItem key={index} id={"right_" + mission} onClick={() => handleRightMissionChange(mission)}>{new Date(Object.values(mission)[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' })}</MenuItem>)
      } else {
        throw Exception('Bad collection_place value');
      }
    })
  }

  return (
    <>
      {upgradeModalIsOpen && <UpgradeModal setIsOpen={setUpgradeModalIsOpen} templateName={'starter'} callOnClose={() => null} />}
      <Wrapper>
        <div style={{ overflow: "hidden" }} data-tour="step-3">
          <p style={copyright}>FastMap &copy; {new Date().getFullYear()}</p>
          {!compareTool && selectedCollection !== undefined && props.maxLevel >= 10 && props.missionDates && props.missionDates.length > 0 && props.missionDates[selected] !== undefined?
            <div>
              <div style={date} data-tour="step-4">
                {window.demonstrable_collections[selectedCollection].name}
                <Tooltip title={"Select Collection"} classes={classes}>
                  <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 5 }} onClick={(evt) => {setCollectionMenuAnchorEl(evt.currentTarget)}}>
                    <ArrowDropUp />
                  </ButtonIcon>
                </Tooltip>
                <Menu anchorEl={collectionMenuAnchorEl} open={collectionMenuOpen} onClose={() => setCollectionMenuAnchorEl(null)} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{ marginBottom: 20 }}>
                  {getCollectionMenuItems('main')}
                </Menu>
              </div>
              <div style={date} data-tour="step-5">
                <Tooltip title={"Select Date"} classes={classes} >
                  <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 10, marginBottom: 2 }} onClick={(evt) => {setMenuAnchorEl(evt.currentTarget)}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 0 24 24" width="15px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" /></svg>
                  </ButtonIcon>
                </Tooltip>
                <Menu anchorEl={menuAnchorEl} open={menuOpen} onClose={() => setMenuAnchorEl(null)} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{ marginBottom: 20 }}>
                  {getMissionMenuItems('main')}
                </Menu>
              </div>
              <div style={date}>Image Date:
                <Tooltip title={"Previous"} classes={classes}>
                  <ButtonIcon style={{ padding: 0, marginLeft: 5, marginRight: 10, marginBottom: 2 }} onClick={prevDate}>
                    <ChevronLeft />
                  </ButtonIcon>
                </Tooltip>
                {new Date(props.missionDates[selected][Object.keys(props.missionDates[selected])]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' })}
                <Tooltip title={"Next"} classes={classes} >
                  <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 5, marginBottom: 2 }} onClick={nextDate}>
                    <ChevronRight />
                  </ButtonIcon>
                </Tooltip>
              </div>
              <div style={date} data-tour="step-6">
                <Tooltip title={"Image Info"} classes={classes} >
                  <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 10, marginBottom: 2 }} onClick={imageInfo}>
                    <InfoOutlined />
                  </ButtonIcon>
                </Tooltip>
              </div>
            </div>
          : null}
          {compareTool && leftCollection !== undefined && rightCollection !== undefined && props.maxLevel >= 10 && props.missionDates && props.missionDates.length > 0  ?
            <div>
              <div>
                <div style={{ ...compareDateLeft, left: 'calc(50% - 150px)' }}>
                  {window.demonstrable_collections[leftCollection].name}
                  <Tooltip title={"Select Collections"} classes={classes}>
                    <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 5 }} onClick={(evt) => { setLeftCollectionMenuAnchorEl(evt.currentTarget)}}>
                      <ArrowDropUp />
                    </ButtonIcon>
                  </Tooltip>
                  <Menu anchorEl={leftCollectionMenuAnchorEl} open={leftCollectionMenuOpen} onClose={() => setLeftCollectionMenuAnchorEl(null)} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{ marginBottom: 20 }}>
                    {getCollectionMenuItems('left_split')}
                  </Menu>
                </div>
                <div style={compareDateLeft}>
                  {leftMissionDate ? new Date(Object.values(leftMissionDate)[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' }) : null}
                  <Tooltip title={"Select Date"} classes={classes} >
                    <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 10, marginBottom: 2 }} onClick={(evt) => { setLeftMenuAnchorEl(evt.currentTarget) }}>
                      <ArrowDropDown />
                    </ButtonIcon>
                  </Tooltip>
                  <Menu anchorEl={leftMenuAnchorEl} open={leftMenuOpen} onClose={() => setLeftMenuAnchorEl(null)} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{marginBottom: 20}}>
                    {getMissionMenuItems('left_split')}
                  </Menu>
                </div>
              </div>
              {compareTool === true ? <Compare style={{ position: "absolute", left: 'calc(50% - 7.5px)' }} /> : null}
              <div>
                <div style={compareDateRight}>
                  <Tooltip title={"Select Date"} classes={classes} >
                    <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 10, marginBottom: 2 }} onClick={(evt) => { setRightMenuAnchorEl(evt.currentTarget) }}>
                      <ArrowDropDown />
                    </ButtonIcon>
                  </Tooltip>
                  <Menu anchorEl={rightMenuAnchorEl} open={rightMenuOpen} onClose={() => { setRightMenuAnchorEl(null); }} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{ marginBottom: 20 }}>
                    {getMissionMenuItems('right_split')}
                  </Menu>
                  {rightMissionDate ? new Date(Object.values(rightMissionDate)[0]).toLocaleDateString("en-CA", { year: 'numeric', month: "long", day: 'numeric' }) : null}
                </div>
                <div style={{ ...compareDateRight, marginLeft: 150 }}>
                  {window.demonstrable_collections[rightCollection].name}
                  <Tooltip title={"Select Collections"} classes={classes}>
                    <ButtonIcon style={{ padding: 0, marginLeft: 10, marginRight: 5 }} onClick={(evt) => setRightCollectionMenuAnchorEl(evt.currentTarget)}>
                      <ArrowDropUp />
                    </ButtonIcon>
                  </Tooltip>
                  <Menu anchorEl={rightCollectionMenuAnchorEl} open={rightCollectionMenuOpen} onClose={() => setRightCollectionMenuAnchorEl(null)} anchorOrigin={{vertical: 'top', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}} style={{ marginBottom: 20 }}>
                    {getCollectionMenuItems('right_split')}
                  </Menu>
                </div>
              </div>
            </div>
          : null}
          <div style={mapdata}>{`${camera_height} ${'  '} ${coordinates} ${'  '} ${coordinates_height}`}</div>
          <div style={{ float: "left", width: 25 }}>
            {props.loading && props.missionDates && props.missionDates.length > 0 ?
              <CircularProgress style={{ float: "left", marginLeft: '10px', marginTop: 1, width: 15, height: 15, background: "#232323" }} />
              : null}
          </div>
        </div>
      </Wrapper>
    </>
  );
}

export default Footer;